
import { GetBaseUrl } from "@/utils/ConfigHelper"
import Response from "@/utils/Videomonster/Common/Response"
import axios from "axios"
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 * @param {string} token 
 * @param {{
 *  agreement: boolean
 *  activatePermanently: boolean
 *  disableEmailNotifications: boolean
 *  optInfosAgreement: boolean
 * }} data
 * @returns {Promise<Response>} 
 * @throws {Error}
 */
const PatchUserAgreementOptions = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/apis/users/agreement-options`
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const body = {
            agreement: data.agreement,
            activatePermanently: data.activatePermanently,
            disableEmailNotifications: data.disableEmailNotifications,
            optInfosAgreement: data.optInfosAgreement
        }
        const response = await axios.patch(url, body, config)
        const result = (response.status === 200)
        const resultData = response.data.data

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    PatchUserAgreementOptions,
}